import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { AnalyticsService } from '@app/core/services/analytics.service';
import { AppService } from '@app/core/services/app.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import packagInfo from '../../../../../package.json';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-imprint',
    templateUrl: './imprint.component.html',
    styleUrls: ['./imprint.component.scss'],
    imports: [AsyncPipe, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class ImprintComponent implements OnInit {
  protected readonly translate = inject(TranslateService);
  private readonly appService = inject(AppService);
  private readonly analyticsService = inject(AnalyticsService);


  protected readonly version: string = packagInfo.version;
  protected readonly userId$ = this.appService.userId$;

  readonly hideTitle = input<boolean | undefined>(undefined);

  ngOnInit(): void {
    this.analyticsService.setDocumentTitleWithExhibitionTitle('Impressum');
  }

}
